// extracted by mini-css-extract-plugin
module.exports = {"normal":"loopButton_normal__1X08w","clicked":"loopButton_clicked__2Dndn","ripple":"loopButton_ripple__2QTfm","animationWrapper":"loopButton_animationWrapper__341kF"};